import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

/** Blue / dashed-blue indicator for whether a call has been reviewed. */
export const CallSeenIndicator = (props: { seenAt?: Date | string | null }) =>
  !props.seenAt ? (
    <div className="size-3 rounded-full bg-blue-500" title="Unseen" />
  ) : (
    <div className="size-3 rounded-full border border-dashed border-blue-500" title="Seen" />
  );

/** Toggle button matching the inbound call-log “Mark as Seen / Unseen” control. */
export const MarkCallSeenButton = (props: {
  seenAt?: Date | string | null;
  disabled?: boolean;
  onToggle: (markSeen: boolean) => void;
}) => {
  const isSeen = !!props.seenAt;
  return (
    <button
      type="button"
      onClick={() => props.onToggle(!isSeen)}
      disabled={props.disabled}
      className="flex items-center gap-1.5 rounded-md bg-white dark:bg-neutral-800 text-sm text-neutral-600 dark:text-neutral-400 hover:text-neutral-700 dark:hover:text-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 px-2 py-1"
      title={isSeen ? 'Mark as Unseen' : 'Mark as Seen'}
    >
      {isSeen ? (
        <>
          <EyeSlashIcon aria-hidden="true" className="h-5 w-5" />
          <span>Mark as Unseen</span>
        </>
      ) : (
        <>
          <EyeIcon aria-hidden="true" className="h-5 w-5" />
          <span>Mark as Seen</span>
        </>
      )}
    </button>
  );
};
